import {
  faSort,
  faBars,
  faSignOutAlt,
  faArrowDown,
  faArrowUp,
  faHome,
  faCircle,
  faSpinner, IconDefinition
} from '@fortawesome/free-solid-svg-icons';

import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';

const fontAwesomeIcons = [
  faSort,
  faBars,
  faHome,
  faSignOutAlt,
  faArrowDown,
  faArrowUp,
  faCircle,
  faSpinner
];

const fontAwesomeRegularIcons = [
  faTimesCircle
];

export const fontAwesomeIconsFinal = [...fontAwesomeIcons, ...fontAwesomeRegularIcons] as IconDefinition[];